import React from "react"
import Scrollbars from "react-custom-scrollbars-2"

import companyCardData from "./cards/NexusCompanyCards"
import { SCROLLBAR, CARD, COMPANY_DASHBOARD_CARD } from "../../modules/constants"
import { LEGEND } from "../../modules/legends"

import Box from '../../components/ThemedBox'
import Card from '../../components/ThemedCard'

import { makeStyles } from "@mui/styles"
import { Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material/'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'
import { normalizeS3Link } from "../../modules/utilities"

import Tooltip from '@mui/material/Tooltip'

// @ts-ignore
const useStyles = makeStyles((theme) => ({
  row: {
    borderBottom: "none"
  },
  rowValue: {
    fontWeight: "bold !important",
    minWidth: 125,
    textAlign: "right !important",
  },
}))

export const NexusDashboard = props => {
  // console.log('props:', props)
  const classes = useStyles()
  const cards = companyCardData(props)
  const advisers = !props.the350club && !!props.entity?.companyProps?.lse?.advisers;

  return (
    <Box variant="container" id="box-container">
      {/* landscape mode, with vertical scrollbar */}
      {!props.portrait && <Scrollbars
        autoHide autoHideTimeout={SCROLLBAR.AH_TIMEOUT} autoHideDuration={SCROLLBAR.AH_DURATION} >
        <CardArray advisers={advisers} cards={cards} classes={classes} portrait={props.portrait} />
      </Scrollbars>
      }

      {/* portrait mode, without vertical scrollbar, as already scrolls in higher level div */}
      {props.portrait && <CardArray advisers={advisers} cards={cards} classes={classes} portrait={props.portrait} />}

    </Box>
  )
}

const CardArray = ({ advisers, cards, classes, portrait }) => {
  // console.log("cards: ", cards)
  return <Box
    variant="envelope"
    id="box-envelope"
    style={{
      flexDirection: portrait ? "column" : "row",
      maxWidth: portrait ? CARD.ENVELOPE.MAXWIDTH / 2 : CARD.ENVELOPE.MAXWIDTH,
      // backgroundColor: "cyan"
    }}
  >

    {/* column 1 */}
    <Box id="column1" style={{ // backgroundColor: "yellow",
      width: portrait ? "100%" : "50%"
    }}
    >
      <OneCard id={COMPANY_DASHBOARD_CARD.CORE} cards={cards} classes={classes}></OneCard>
      <OneCard id={COMPANY_DASHBOARD_CARD.GOVERNANCE} cards={cards} classes={classes}></OneCard>
    </Box>

    {/* column 2 */}
    <Box id="column1" style={{ // backgroundColor: "pink",
      width: portrait ? "100%" : "50%"
    }}
    >
      <OneCard id={COMPANY_DASHBOARD_CARD.BOARD} cards={cards} classes={classes}></OneCard>
      <OneCard id={COMPANY_DASHBOARD_CARD.DATES} cards={cards} classes={classes}></OneCard>
      {/* <OneCard index={COMPANY_DASHBOARD_CARD.BOARD} cards={cards} classes={classes} ></OneCard>
      <OneCard index={COMPANY_DASHBOARD_CARD.DATES} cards={cards} classes={classes} ></OneCard> */}
      {advisers && <OneCard id={COMPANY_DASHBOARD_CARD.ADVISERS} cards={cards} classes={classes} ></OneCard>}
    </Box>

  </Box>
}

const OneCard = props => {
  const { id, cards, classes } = props
  const card = cards.find(obj => obj.id === id)
  // console.log("card: ", card)

  if (!card) return null

  return <Card variant="card" key={id}>
    <Table size="small">

      <TableHead>
        <TableRow className={classes.title}>
          <TableCell className={classes.title} colSpan={2}
            sx={{ fontSize: CARD.TITLE.FONT_SIZE, fontWeight: CARD.TITLE.FONT_WEIGHT, backgroundColor: CARD.TITLE.BACKGROUND_COLOR }}
          >
            {card.title}
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {/* filter out rows which are null */}
        {card.data.filter(row => row !== null).map((row, index) => (
          Array.isArray(row.value) && row.value.length > 0
            ? (<CollapsibleRow key={index} rows={row.value} id={row.id} tooltipTitle={row.tooltipTitle} />)
            : (
              <TableRow key={index}>
                <Tooltip arrow title={row.tooltipTitle ?? ""}>
                  <TableCell component="th" scope="row"
                    style={{ borderTop: row.borderTop }}>
                    {row.label}
                  </TableCell>
                </Tooltip>
                <Tooltip arrow title={row.valueTooltip ?? ""} >
                  <TableCell className={classes.rowValue}
                    style={{ color: row.color, borderTop: row.borderTop }}>

                    {row.link ? (
                      <a
                        href={normalizeS3Link(row.link)}
                        target={row.newTab ? "_blank" : "_self"}
                        // NB: rel="noopener noreferrer" is needed when using target="_blank" to prevent security vulnerabilities and performance issues.
                        // It prevents the new page from being able to access the window.opener property and ensures it runs in a separate process.
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()} // NB: stopPropagation is needed to prevent the onClick from propagating to the row, which would trigger the collapse toggle
                        // If cell color is not set or is black, inherit color from cell. Otherwise, use default link color.
                        style={{
                          color: row.color && row.color !== 'black' ? 'inherit' : undefined,
                          textDecoration: "underline",
                        }}
                      >
                        {row.value}
                      </a>
                    ) : (
                      row.value
                    )}

                  </TableCell>
                </Tooltip>
              </TableRow>
            )
        ))}
      </TableBody>
    </Table>
    {/* </CardActionArea> */}

  </Card>
}


const CollapsibleRow = props => {
  // console.log('CollapsibleRow props:',props);
  const { id, rows, tooltipTitle } = props
  const [open, setOpen] = React.useState(false)
  const classes = useStyles()

  return <React.Fragment>
    {/* <TableRow sx={{ '&> *': { borderBottom: 'unset' } }}> */}
    <TableRow>
      <Tooltip arrow title={tooltipTitle ?? ""}>
        <TableCell component="th" scope="row" align="left" width={"40%"}>
          {LEGEND[id].label}
        </TableCell>
      </Tooltip>

      {rows.length > 1 && <TableCell align="right" className={classes.rowValue}>
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
        {rows.length}
      </TableCell>}

      {rows.length === 1 && <TableCell className={classes.rowValue}>
        {/* For ACTIVITIES row[0] is a value, for PREVIOUS_NAMES row[0] is an object & we use the 'name' property */}
        {rows[0].name ?? rows[0]}
      </TableCell>}
    </TableRow>

    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingRight: 0 }} colSpan={6}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {/* <Box sx={{ margin: 1 }}> */}
          <Box>
            <Table size="small">
              <CollapseBody id={id} rows={rows} />
            </Table>
          </Box>
        </Collapse>
      </TableCell>
    </TableRow>

  </React.Fragment>
}

const CollapseBody = props => {
  // console.log('CollapseBody props:', props);
  const classes = useStyles()
  return <TableBody>
    {props.rows.map((row, index) => (
      <TableRow key={index}>
        <TableCell />
        <Tooltip arrow title={row.valueTooltip ?? ""}>
          <TableCell component="th" scope="row" className={classes.rowValue} style={{ color: row.color, borderTop: row.borderTop }}>
            {row.value}
          </TableCell>
        </Tooltip>
      </TableRow>
    ))}
  </TableBody>
}
